import { useId } from "react";
import PropTypes from "prop-types";
import { HoverCard } from "@hireart/component-library";
import { Full, Value } from "./styles";

export const FullWithHover = ({
  content = "",
  theme,
  category = "",
  hasNoPTO = false,
}) => {
  const popupId = useId();
  const popupContent = hasNoPTO
    ? "No hours available"
    : `${content} hours ${category}`;
  const valueDisplay = hasNoPTO ? "Not available" : content;

  return (
    <HoverCard
      id={popupId}
      content={popupContent}
      trigger={
        <Full style={theme}>
          <Value>{valueDisplay}</Value>
        </Full>
      }
    />
  );
};

FullWithHover.propTypes = {
  content: PropTypes.string,
  hasNoPTO: PropTypes.bool,
  theme: PropTypes.shape({}).isRequired,
  category: PropTypes.string,
};
